module.exports = __webpack_public_path__ + "static/media/addi.478ac05c.svg";